// extracted by mini-css-extract-plugin
export default {"default":"Radio_default__eG6xb","radio_item":"Radio_radio_item__GoVPq"};